export const sanitizePastedHTML = (html: string): string => {
  return html
    .replace(/<(\/?)th(\s|>)/gi, '<$1td$2')
    .replace(/<pre>\s*<pre>/gi, '<pre>')
    .replace(/<\/pre>\s*<\/pre>/gi, '</pre>')
    .replace(/<p\b([^>]*)>\s*(<p>\s*<\/p>\s*)+/gi, (match, attrs) => {
      const count = (match.match(/<p>\s*<\/p>/gi) || []).length
      return '<p></p>'.repeat(count) + `<p${attrs}>`
    })
    .replace(/<p\b[^>]*>\s*<\/p>/gi, (match, offset, str) => {
      const before = str.substring(0, offset)
      const openCount = (before.match(/<p\b[^>]*>/gi) || []).length
      const closeCount = (before.match(/<\/p>/gi) || []).length
      return openCount > closeCount ? `</p>${match}<p>` : match
    })
}
